import { Tooltip } from 'antd';
import React from 'react';
import "./styles.css";

interface Props {
    children?: React.ReactNode;
    title: string;
    stagioIndex: number;
    index: number;
}

const TooltipStagio: React.FunctionComponent<Props> = ({ children, title, stagioIndex, index }: Props) => {
    return (
        <Tooltip title={title} color={index <= stagioIndex ? '#304FFE' : ''}>
            <span>{children}</span>
        </Tooltip>
    );
}

export default TooltipStagio;